import ReactGA from "react-ga4";
import { GA_TRACKING_ID } from "./utils";

console.log("ga.ts : ", GA_TRACKING_ID);
if (GA_TRACKING_ID) ReactGA.initialize(GA_TRACKING_ID);

// Initialize Firebase
const logEvent = (eventName: string, data: any) => {
  console.log(`[logEvent] 이벤트 전송: ${eventName}`, data);
  try {
    ReactGA.event(eventName, data);
    console.log(`[logEvent] ✅ 이벤트 전송 완료: ${eventName}`);
  } catch (error) {
    console.error(`[logEvent] ❌ 이벤트 전송 실패: ${eventName}`, error);
  }
};

type PageMoveData = {
  destination_page: string;
  source_page?: string;
  [key: string]: any;
}
const logPageMoveEvent = (data: PageMoveData) => {
  let targetUrl: string | null = null;

  // h2mwbell://webview?url= 형식 처리
  const urlMatch = data.destination_page.match(/url=([^&]+)/);
  if (urlMatch) {
    targetUrl = urlMatch[1];
  }
  // host가 포함된 형식 처리 - ${HOSTNAME}/booking/hall?hidetop=true
  if (!targetUrl && data.destination_page.startsWith('http')) {
    targetUrl = data.destination_page;
  }
  // 경로만 있는 경우 - /booking/hall?hidetop=true
  if (!targetUrl) {
    targetUrl = window.location.origin + data.destination_page;  // 상대 경로 처리
  }
  // URL 객체 생성
  const urlObj = new URL(targetUrl);
  const path = urlObj.pathname;
  const search = urlObj.search;
  if (urlObj.host !== window.location.host) {
    // 다른 도메인으로 이동하는 경우
    data.destination_page = urlObj.origin + path;
  } else {
    // 같은 도메인으로 이동하는 경우
    data.destination_page = path;
  }
  data.destination_page_search = search;
  if (data.source_page === undefined) {
    // source_page 명시 안하면 현재 페이지로 설정
    data.source_page = window.location.pathname;
  }
  console.log(data);
  if (data.source_page && data.destination_page) {
    ReactGA.event('page_move', data);
  } else {
    console.error('logPageMoveEvent: source_page, destination_page is required');
  }
}
export { logEvent, logPageMoveEvent };
